import { Box } from '@chakra-ui/react';

interface IDefaultToolbarProps {
  HeaderComponents: JSX.Element[];
}

/**
 * Default toolbar generalised for use with the admissions and cas workflow dashboards.
 *
 * Just a container that holds divided actions.
 */
export const DefaultToolbar = (props: IDefaultToolbarProps) => {
  const { HeaderComponents } = props;
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" my={2} height={10}>
      {HeaderComponents.map((Comp, index) => (
        <Box display="flex" justifyContent="left" alignItems="center" key={index}>
          {Comp}
        </Box>
      ))}
    </Box>
  );
};
